import { Accordion, AccordionDetails, AccordionSummary, Box, styled, Typography } from '@mui/material';
import React from 'react';

export const ItemContainer = styled(Box)(({ theme: { spacing } }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: spacing(2),
}));

export const ItemBody = styled(Box)(({ theme: { spacing } }) => ({
  paddingLeft: spacing(4.75),
  gap: spacing(2),
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
  position: 'relative',
}));

export const LogoWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasTransparency',
})<{ hasTransparency: boolean }>(({ hasTransparency, theme: { spacing, palette } }) => ({
  width: 80,
  height: 80,
  borderRadius: spacing(0.5),
  border: `1px solid ${palette.action.focus}`,
  opacity: hasTransparency ? 0.5 : 1,
  overflow: 'hidden',
}));
export const LogoImage = styled(Box)<{ component: React.ElementType; src: string; alt: string; loading: string }>({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});

export const ItemContentContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const ItemTextName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'hasTransparency',
})<{ hasTransparency: boolean }>(({ hasTransparency, theme: { typography, palette } }) => ({
  width: 300,
  fontWeight: typography.fontWeightMedium,
  lineHeight: '19px',
  color: hasTransparency ? palette.text.disabled : palette.text.primary,
}));

export const ItemControlsContainer = styled(Box)(({ theme: { spacing } }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'row',
  gap: spacing(1),
  zIndex: 999,
}));

export const ItemFooter = styled(Box)(({ theme: { spacing } }) => ({
  marginTop: spacing(1),
  marginBottom: spacing(0.625),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: spacing(3),
}));

export const ItemAmountInfo = styled(Box)(({ theme: { spacing, palette } }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: spacing(1),
  alignItems: 'center',
  color: palette.text.primary,
}));

export const ItemQuantityAndPrice = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEditModeEnabled',
})<{ isEditModeEnabled: boolean }>(({ isEditModeEnabled }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: isEditModeEnabled ? 201 : 170,
}));

export const QuantitySelectorErrorTextContainer = styled(Box)({
  position: 'absolute',
  bottom: -22,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
});

export const StyledAccordion = styled(Accordion)({
  boxShadow: 'none',
  '&:before': { display: 'none' },
  '&.Mui-expanded': {
    margin: 0,
  },
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  position: 'relative',
  margin: 0,
  padding: 0,
  minHeight: 'auto',
  '&.Mui-expanded': {
    margin: 0,
    minHeight: 'auto',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent',
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'translateY(-50%) rotate(90deg)',
    transformOrigin: 'center',
  },
});

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme: { spacing } }) => ({
  padding: 0,
  paddingTop: spacing(2),
  paddingLeft: spacing(7.75),
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(2),
}));
